/*
 * Main JS file for JS imports.
 */

// Chromatix global variables
window.chrGlobal = {
  mobileNavBreak:   1024,
  headerHeightDesk: 70, // Height after scroll
  headerHeightMob:  60,
};
require( './global/dropdown' );
require( './global/dropdown-video-page' );
require( './global/load-effect' );
require( './global/header' );
require( './global/footer' );
require( './global/mega-menu' );
require( './global/scroll-to' );
require( './global/sidebar' );
require( './global/filter' );
require( './global/documentation-filter' );
require( './global/generic-tab-interactions' );
require( './global/all-products' );
require( './global/support' );
require( './global/video-lazy-load' );
require( './global/chatbot' );
require( './global/blog' );
require( './global/dynamic-height' );
require( './global/webinar-slider' );

// Fix foundation resize from responsive to desktop, dropdown menu bug.
jQuery( window ).on( 'changed.zf.mediaquery', ( event, newSize, oldSize ) => {

  if ( window.chr_scripts.auto_refresh === 'on' &&
      newSize.indexOf( 'large' ) !== -1 && oldSize.indexOf( 'large' ) === -1 ) {
    location.reload();
  }

  if ( window.chr_scripts.auto_refresh === 'on' &&
      newSize.indexOf( 'medium' ) !== -1 && oldSize.indexOf( 'small' ) === -1 ) {
    location.reload();
  }

});
